// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section[data-v-155a0dc8]{padding:.5rem 1rem 1rem 1rem;height:auto;overflow:hidden;border-bottom:1px solid #d3d3d3}.columns[data-v-155a0dc8]{padding-bottom:1rem}.taxon-container-loading[data-v-155a0dc8]{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;min-height:16rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
